module.exports = __webpack_public_path__ + "img/home_34.c2b8d962.png";